import ClassRoomBasicAnalytics from './ClassRoomBasicAnalytics';

export default ClassRoomBasicAnalytics;
